import { render, staticRenderFns } from "./AssignPrescriberModal.vue?vue&type=template&id=d0f76e30"
import script from "./AssignPrescriberModal.vue?vue&type=script&lang=js"
export * from "./AssignPrescriberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports